import React from 'react'
import { HelpTooltip } from 'components/Tooltip/HelpTooltip'
import { Tooltip } from 'components/Tooltip/tooltip'
import FbButton from 'components/FbUI/FbButton'
import {
  Preview,
  Section,
  Row,
  Col,
} from 'component-catalog/previews/PreviewKit'

export function TooltipMock(): React.ReactElement {
  return (
    <Preview>
      {/* ------------------------------------------------------------------ */}
      {/* HelpTooltip — info icon that opens a styled tooltip panel           */}
      {/* ------------------------------------------------------------------ */}
      <Section label="HelpTooltip — hover the ⓘ icon">
        <Col>
          <Row label="Title + short content">
            <div className="flex items-center gap-1.5 text-sm text-fg">
              Revenue
              <HelpTooltip
                title="Annual Revenue"
                content="Estimated annual revenue."
              />
            </div>
          </Row>
          <Row label="Title + content">
            <div className="flex items-center gap-1.5 text-sm text-fg">
              LTV
              <HelpTooltip
                title="Lifetime Value"
                content="Estimated revenue over the full customer relationship based on deal size and contract length."
              />
            </div>
          </Row>
          <Row label="Title + content + link">
            <div className="flex items-center gap-1.5 text-sm text-fg">
              Win Rate
              <HelpTooltip
                title="Win Rate"
                content="Percentage of deals closed as won versus total closed deals in the period."
                link={{ text: 'Learn more', href: 'https://example.com' }}
              />
            </div>
          </Row>
        </Col>
      </Section>

      {/* ------------------------------------------------------------------ */}
      {/* Tooltip — generic hover wrapper for any element                     */}
      {/* ------------------------------------------------------------------ */}
      <Section label="Tooltip — wraps any child element">
        <Row label="Placements (hover each button)">
          {(['top', 'bottom', 'left', 'right'] as const).map((placement) => (
            <Tooltip
              key={placement}
              content={`Placement: ${placement}`}
              placement={placement}
            >
              <FbButton size="xs" variant="secondary">
                {placement}
              </FbButton>
            </Tooltip>
          ))}
        </Row>
        <Row label="With title + content panel">
          <Tooltip
            title="Delete permanently"
            content="This action cannot be undone. The record and all associated data will be removed."
            placement="top"
          >
            <FbButton size="sm" variant="danger">
              Delete
            </FbButton>
          </Tooltip>
        </Row>
        <Row label="wrapTrigger=false (no wrapper div around child)">
          <Tooltip
            content="Tooltip without wrapping div — child is the direct Tippy target"
            placement="bottom"
            wrapTrigger={false}
          >
            <FbButton size="sm" variant="secondary">
              No wrap div
            </FbButton>
          </Tooltip>
        </Row>
      </Section>
    </Preview>
  )
}
